import React          from 'react'
import ReactDOM       from 'react-dom'
import Styleguide     from './styleguide/Styleguide.jsx'

ReactDOM.render(<Styleguide/>, document.getElementById('main'))
